/**
 * Ubicación meteorológica — Casa León, Los Corralitos (no centro de Mendoza ciudad).
 * Coordenadas verificadas vía OpenStreetMap Nominatim (oct 2026):
 * - Calle Severo del Castillo, Distrito Los Corralitos, Guaymallén.
 * - Referencia cruzada: intersección con María Elena Walsh (~-32.90237, -68.70092).
 * Punto de consulta: tramo de Severo del Castillo en zona M5525 / dirección declarada 4736.
 */
export const CASA_LEON_WEATHER_SITE = {
  name: 'Casa León',
  addressLine: 'Severo del Castillo 4736, Los Corralitos, Mendoza, Argentina',
  referenceNote: 'Referencia OSM: Severo del Castillo × María Elena Walsh, Los Corralitos',
  latitude: -32.90365,
  longitude: -68.70112,
  timezone: 'America/Argentina/Mendoza',
} as const;

export const WEATHER_DATA_SOURCE = {
  provider: 'Open-Meteo',
  apiBase: 'https://api.open-meteo.com/v1/forecast',
  licenseUrl: 'https://open-meteo.com/en/license',
  attribution: 'Datos meteorológicos por Open-Meteo.com (CC BY 4.0)',
} as const;
